var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("addEmail"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  key: "server_channel",
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "server_channel",
                    label: _vm.$t("serverChannel")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "show_test",
                  staticClass: "lodingItem",
                  attrs: { prop: "show_test", label: _vm.$t("showTestServer") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "server_id",
                  staticClass: "lodingItem",
                  attrs: { prop: "server_id", label: _vm.$t("server") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        clearable: "",
                        "collapse-tags": "",
                        multiple: "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.serverIdChange },
                      model: {
                        value: _vm.paramsData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_id", $$v)
                        },
                        expression: "paramsData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "type",
                  staticClass: "lodingItem",
                  attrs: { prop: "type", label: _vm.$t("emailType") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: { placeholder: _vm.$t("pleaseSelectType") },
                      model: {
                        value: _vm.paramsData.type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "type", $$v)
                        },
                        expression: "paramsData.type"
                      }
                    },
                    _vm._l(_vm.emailType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.type == "compensate"
                ? _c(
                    "el-form-item",
                    {
                      key: "expires",
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "start_time",
                        rules: _vm.rules.expires,
                        label: _vm.$t("time")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          align: "right",
                          "range-separator": _vm.$t("range"),
                          "start-placeholder": _vm.$t("startTime"),
                          "end-placeholder": _vm.$t("endTime")
                        },
                        on: { change: _vm.searchTimeChange },
                        model: {
                          value: _vm.expires,
                          callback: function($$v) {
                            _vm.expires = $$v
                          },
                          expression: "expires"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  key: "expire",
                  staticClass: "lodingItem",
                  attrs: { prop: "expire", label: _vm.$t("expireTime") }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      clearable: false,
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetime",
                      placeholder: _vm.$t("pleaseSelectExpireTime")
                    },
                    model: {
                      value: _vm.paramsData.expire,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "expire", $$v)
                      },
                      expression: "paramsData.expire"
                    }
                  })
                ],
                1
              ),
              _vm.paramsData.type == "to_users"
                ? _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    _vm._l(_vm.paramsData.serverData, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "x-bc",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: { label: _vm.$t("server") }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "operationFrame-entity",
                                  attrs: {
                                    disabled: "",
                                    clearable: "",
                                    filterable: "",
                                    placeholder: _vm.$t("server")
                                  },
                                  model: {
                                    value: item.label,
                                    callback: function($$v) {
                                      _vm.$set(item, "label", $$v)
                                    },
                                    expression: "item.label"
                                  }
                                },
                                _vm._l(_vm.serverListYJ, function(item) {
                                  return _c("el-option", {
                                    key: item.serverID,
                                    attrs: {
                                      label: item.serverName,
                                      value: item.serverID
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "lodingItem",
                              attrs: {
                                prop: "serverData." + index + ".value",
                                rules: _vm.rules.uids,
                                label: _vm.$t("playerId")
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  placeholder: _vm.$t("roleIdPlaceholder")
                                },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              }),
                              _c("uploadImagetow", {
                                ref: "uploadImagetow",
                                refInFor: true,
                                staticStyle: { "margin-left": "20px" },
                                attrs: {
                                  paramsData: { env_id: _vm.propsData.env_id },
                                  fileType: ".txt",
                                  filesname: "txt",
                                  Url: "/sz-gm/upload_txt",
                                  title: _vm.$t("uploadTxt")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.fileUp($event, index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    round: "",
                    disabled: _vm.isPermissions
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("send")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }